import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../app/hooks";
import bestAvailableModelSlice from "../data/slices/best-available-model-slice";


export const ZoneDropdown: React.FC = () => {
    const bestAvailableText = useAppSelector((state) => state.bestAvailableText);
    const zoneInformation = useAppSelector((state) => state.bestAvailableModel.zoneInformation);
    const [currentZoneInformation, setCurrentZoneInformation] = useState(zoneInformation);
    const selectedZoneId = useAppSelector((state) => state.bestAvailableModel.selectedZoneId);
    const [currentSelectedZoneId, setCurrentSelectedZoneId] = useState(selectedZoneId);
    const dispatch = useDispatch();

    useEffect(() => { setCurrentZoneInformation(zoneInformation) }, [zoneInformation])
    useEffect(() => { setCurrentSelectedZoneId(selectedZoneId) }, [selectedZoneId])

    function onDropdownSelection(evt) {
        const newZoneId = Number(evt.target.value);
        dispatch(bestAvailableModelSlice.actions.updateSelectedZone(newZoneId));
    }

    return (
        <div>
            <label htmlFor="zone-dropdown">{bestAvailableText.zoneLabel}</label>
            <select id="zone-dropdown" onChange={onDropdownSelection} defaultValue={currentSelectedZoneId}>
                {currentZoneInformation.map((zone) => (
                    <option key={zone.id} value={zone.id} disabled={zone.isDisabled}>
                        {zone.descriptionWithPriceRange}
                    </option>
                ))}
            </select>
        </div>
    )
}